require('./src/scss/prism-a11y-dark.scss');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');
